/**
 * Created by Arif Topcu in 2019
 */

import React, { memo, useMemo } from "react";
import PropTypes from "prop-types";
import Combobox from "@ls/react-combobox-grid";
import {
  selectAnalyticValuesSelectionOptions,
  selectFetchingAnalyticValues,
} from "state/analytics/selectors";
import { useSelector } from "react-redux";
import { summaryTypeOptions } from "state/selections/Constants/SummaryType";
import { Grid, Cell } from "styled-css-grid";
import { scaleTypeOptions } from "state/Constants/ScaleType";

const AnalyticsSelectorComplication = ({ setDefinition, definition }) => {
  const analyticOptions = useSelector(selectAnalyticValuesSelectionOptions);
  const fetchingAnalyticValues = useSelector(selectFetchingAnalyticValues);

  const [setAnalytic, setScaleType, setSummary] = useMemo(() => {
    return [
      (value) => setDefinition(definition.setAnalytic(value)),
      (value) => setDefinition(definition.setScaleType(value)),
      (value) => setDefinition(definition.setSummary(value)),
    ];
  }, [definition, setDefinition]);

  return (
    <Grid columns={12} gap="4px">
      <Cell width={6}>
        <Combobox
          options={analyticOptions}
          onChange={setAnalytic}
          isLoading={fetchingAnalyticValues}
          value={definition.analytic}
          label="Analytic:"
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={scaleTypeOptions}
          onChange={setScaleType}
          value={definition.scaleType}
          label="Type:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={175}
        />
      </Cell>
      <Cell width={3}>
        <Combobox
          options={summaryTypeOptions}
          onChange={setSummary}
          value={definition.summary}
          label="Acc/Bmk/Rel:"
          clearable={false}
          variation={0}
          size={"S"}
          gridHeight={125}
          disabled={definition.scaleType === "RATIO"}
        />
      </Cell>
    </Grid>
  );
};

AnalyticsSelectorComplication.propTypes = {
  setDefinition: PropTypes.func.isRequired,
  definition: PropTypes.object.isRequired,
};

export default memo(AnalyticsSelectorComplication);
